// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__qZv+U","loaderText":"loader_loaderText__Ja5-o","delayMessage":"loader_delayMessage__HOKO7"};